<template>
  <div class="container-margin">
    <v-row class="mx-0">
      <v-col cols="12" class="mt-10">
        <img width="100%" src="@/assets/index1.png" alt="index">
      </v-col>
      <v-col cols="12" class="mx-0 px-0">
        <img width="90" class="custom-shape-red" src="@/assets/red-dots.png" alt="red-dots">
        <img width="80" class="custom-shape-circle-red" src="@/assets/shape-02.png" alt="red-circle">
        <img width="90" class="custom-shape-green" src="@/assets/some-point.png" alt="green-dots">
        <!--        <img width="110" alt="dorakk" src="@/assets/dorakk-logo.png" class="dorak-logo"/>-->
        <div class="text-learn-music">
          آموزش موسیقی
        </div>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12">
            <img v-if="!showVideo" @click="showVideo = true" src="@/assets/play.png" class="play-image"
                 width="80%"
                 alt="index">
            <video autoplay controls v-if="showVideo" class="play-video"
                   src="@/assets/video-inter.mp4"></video>
          </v-col>
          <v-col cols="12" class="dorak-description-big mx-0 px-0 text-center">
            یکی از دوره های آموزشی دُرَک، دوره آشنایی با ریتم برای کودکان است
          </v-col>
          <v-col cols="12" class="dorak-description-small mx-0 px-0 text-center">
            برای دیدن ویدیو کلیپ روی تصویر کلیک کنید
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-center text-description-using">برای استفاده از دوره های آموزشی ابتدا باید
        <a @click="$router.push('/register')">عضو</a>
        شوید
      </v-col>
      <v-col cols="12" class="text-center text-courses-title">دوره های آموزشی</v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12" v-for="course in courses" :key="course.id">
            <v-card>
              <v-card-title>
                {{ course.title }}
              </v-card-title>
              <v-card-text>
                <img width="100%" height="150px" :src="course.cover_file" :alt="course.title">
              </v-card-text>
              <v-card-subtitle>
                {{ course.description }}
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" class="text-center">
        <v-text-field placeholder="مشاوره می خواهید ؟ شماره خود را وارد کنید." class="news-text-field"
                      background-color="white" color="white" outlined append-outer-icon="mdi-phone">
        </v-text-field>
        <v-btn class="submit-register-news" fab elevation="0" small>
          <v-icon color="#1ab69d">mdi-check</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" class="footer-container">
        <v-row>
          <v-col cols="12" class="text-center">
            <img height="100" src="@/assets/dorakk-footer-logo.png" alt="">
          </v-col>
          <v-col cols="12" class="pt-16">
            <v-row>
              <v-col cols="12" class="white--text">
                <span class="footer-link">
                  <v-icon class="footer-circle-icon" color="white">mdi-circle-outline</v-icon>
                  درباره دُرَک
                </span>
              </v-col>
              <v-col cols="12" class="white--text">
                <span class="footer-link">
                  <v-icon class="footer-circle-icon" color="white">mdi-circle-outline</v-icon>
                  تماس با دُرَک
                </span>
              </v-col>
              <v-col cols="12" class="white--text">
                <span class="footer-link">
                  <v-icon class="footer-circle-icon" color="white">mdi-circle-outline</v-icon>
                  بلاگ
                </span>
              </v-col>
              <v-col cols="12" class="white--text">
                <span class="footer-link">
                  <v-icon class="footer-circle-icon" color="white">mdi-circle-outline</v-icon>
                  همکاری با دُرَک
                </span>
              </v-col>
              <v-col cols="12">
                <v-icon large class="mx-2 footer-link" color="white">mdi-instagram</v-icon>
                <v-icon large class="mx-2 footer-link" color="white">mdi-twitter</v-icon>
                <v-icon large class="mx-2 footer-link" color="white">mdi-facebook</v-icon>
                <a
                    style="left: 0!important;position: absolute!important;top: 250px!important;"
                    referrerpolicy='origin' target='_blank' href='https://trustseal.enamad.ir/?id=575480&Code=tpIJy52YrvARfb63pjrILDbMmjj3VCPV'>
                  <img referrerpolicy='origin' src='https://trustseal.enamad.ir/logo.aspx?id=575480&Code=tpIJy52YrvARfb63pjrILDbMmjj3VCPV' alt='' style='cursor:pointer;width: 90px;height: 90px' code='tpIJy52YrvARfb63pjrILDbMmjj3VCPV'>
                </a>
              </v-col>
              <v-col>
                <br>
                <br>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'HomeMobile',
  data() {
    return {
      showVideo: false,
      courses: []
    }
  },
  methods: {
    getCourses() {
      window.axios.get('course/crud/home-courses').then((res) => {
        this.courses = res.data.data
      }).catch(() => {
      })
    }
  },
  mounted() {
    this.getCourses()
  }
}
</script>
<style scoped>
.container-margin {
  margin: -1vh 0 8vw 8vw;
  width: 100%;
}

.text-learn-music {
  position: absolute;
  z-index: 2;
  right: 7vw;
  font-size: 6vw;
  top: 27vh;
}

.title-big-home {
  font-size: 2.7vw !important;
  color: black;
}

.custom-margin-first-title {
  margin-top: 15vh !important;
  margin-right: 15vw !important;
}

.dorak-logo {
  position: absolute;
  top: 90vh;
  animation-name: dorak-logo;
  animation-duration: 6s;
  animation-iteration-count: infinite;
}

@keyframes dorak-logo {
  0% {
    transform: rotate(-5deg)
  }
  50% {
    transform: rotate(5deg)
  }
  100% {
    transform: rotate(-5deg)
  }
}

.custom-shape-red {
  z-index: 2;
  position: absolute;
  top: 25vh;
  right: 4vw;
  transform: rotate(-5deg);
  animation-name: shape-dot-red;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

@keyframes shape-dot-red {
  0% {
    top: 25vh;
    transform: rotate(-5deg)
  }
  50% {
    transform: rotate(5deg);
    top: 21vh
  }
  100% {
    top: 25vh;
    transform: rotate(-5deg)
  }
}

.custom-shape-circle-red {
  position: absolute;
  top: 24vh;
  right: 4vw;
  animation-name: shape-circle-red;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

@keyframes shape-circle-red {
  0% {
    right: 4vw;
    transform: rotate(-5deg)
  }
  50% {
    right: 3vw;
    transform: rotate(45deg);
  }
  100% {
    right: 4vw;
    transform: rotate(-5deg);
  }
}

.custom-shape-green {
  z-index: 2;
  position: absolute;
  top: 25vh;
  right: 4vw;
  transform: rotate(5deg);
  animation-name: shape-dot-green;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

@keyframes shape-dot-green {
  0% {
    transform: rotate(5deg)
  }
  50% {
    transform: rotate(-5deg);
    top: 29vh
  }
  100% {
    transform: rotate(5deg);
    top: 25vh
  }
}

.custom-shape-line {
  position: absolute;
  top: 42vh;
  right: 35vw;
  z-index: 2;
  animation-name: shape-line-green;
  animation-duration: 4s;
  animation-iteration-count: infinite;
}

@keyframes shape-line-green {
  0% {
    transform: rotate(-5deg)
  }
  50% {
    transform: rotate(45deg);
  }
  100% {
    transform: rotate(-5deg);
  }
}

.dorak-description-small {
  font-size: 2.4vw !important;
  color: black;
}

.dorak-description-big {
  font-size: 3vw !important;
  color: black;
}

.play-image {
  position: absolute;
  z-index: 1;
  right: 6.5vw;
  top: 65vh;
}

.play-image:hover {
  transform: rotate(-2deg);
}

.play-video {
  width: 100%;
  position: absolute;
  z-index: 2;
  right: 1vw;
  top: 55vh;
}

.text-description-using {
  margin-top: 35vh;
  font-size: 3.5vw;
  color: black;
  margin-right: 4vw;
}

.text-courses-title {
  font-size: 3vw;
  color: black;
  margin-right: 5vw;
}

.footer-container {
  //position: absolute;
  //top: 120vh;
  //margin-top: 40vh !important;
  //bottom: 200px!important;
  left: 0;
  background-color: black;
  background-image: url("/src/assets/footer-bg.webp");
  border-radius: 5px 5px 0 0;
}


.dorakk-logo-footer {
  animation-name: dorakk-footer-logo;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes dorakk-footer-logo {
  0% {
    transform: rotate(-1deg)
  }
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-1deg);
  }
}

.footer-link {
  cursor: pointer;
}

.footer-link:hover {
  transform: rotate(45deg) !important;
  color: #1ab69d !important;
}

.news-text-field {
  width: 80%;
  font-size: 3.3vw;
  right: 9vw;
}

.submit-register-news {
  right: -42vw;
  animation-name: submit-button-news;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes submit-button-news {
  0% {
    transform: rotate(-30deg)
  }
  50% {
    transform: rotate(30deg);
  }
  100% {
    transform: rotate(-30deg);
  }
}

.footer-circle-icon:hover {
  color: #1ab69d !important;
}
</style>